import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getFormDetailsClientSide, getSignedAgreementClientSide, saveAgreementDetails } from '../../../services/on-boarding-service/OnBoardingService';
import Snackbar from '../../toastrmessage/Snackbar';
import { material } from '../../../library/material';
import './NursesAgreement.css';
import SignaturePad from 'react-signature-canvas';
import { useForm } from 'react-hook-form';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import moment from 'moment';

var sigPad = {};

function NursesAgreement(props) {
    const { formId } = useParams()
    const navigate = useNavigate();
    const { register, handleSubmit, setError, reset, formState: { errors } } = useForm({
        mode: "onTouched"
    });
    const [date, setDate] = useState(dayjs(new Date()));
    const [openSnackBar, setOpenSnackBar] = useState({
        "action": false,
        "type": "",
        "message": "",
    });
    const [getSubmittedData, setGetSubmittedData] = useState(null);
    const [getSignatureAgreementData, setGetSignatureAgreementData] = useState(null);

    useEffect(() => {
        getSubmittedFormData();
        getSignedAgreementData();
    }, []);

    const getSubmittedFormData = () => {
        getFormDetailsClientSide(formId)
            .then((resp) => {
                setGetSubmittedData(resp.data);
            })
            .catch((error) => {
                setOpenSnackBar({
                    "action": true,
                    "type": "error",
                    "message": error.response?.data?.message,
                })
            })
    };

    const getSignedAgreementData = () => {
        getSignedAgreementClientSide(formId)
            .then((resp) => {
                setGetSignatureAgreementData(resp.data);
                reset(resp.data.data?.data)
            })
            .catch((error) => {
                setOpenSnackBar({
                    "action": true,
                    "type": "error",
                    "message": error.response?.data?.message,
                })
            })
    };

    const saveAgreement = (formData) => {
        const payload = {
            formId: formId,
            data: {
                ...formData,
                date: moment(date.$d).format("MM-DD-YYYY"),
                nurseSignature: sigPad.getTrimmedCanvas().toDataURL('image/png')
            }
        }
        saveAgreementDetails(payload)
            .then((resp) => {
                setOpenSnackBar({
                    "action": true,
                    "type": "success",
                    "message": resp.data,
                })
                reset({});
                reset({ date: "" });
                sigPad = {};
                navigate("/login");
                navigate("/supporting-document-upload", { state: { formDetails: { ...getSubmittedData, formId: formId } } })
            })
            .catch((error) => {
                setOpenSnackBar({
                    "action": true,
                    "type": "error",
                    "message": error.response?.data?.message,
                })
            })
    };

    const uploadDocument = () => {
        navigate("/supporting-document-upload", { state: { formDetails: { ...getSubmittedData, formId: formId } } })
    };

    const clear = () => {
        sigPad.clear()
    };

    return (
        <div className='form-container'>
            <div className="scrollable-content">
                <h2 style={{ textAlign: "center" }}>USER AGREEMENT</h2>
                <p style={{ textAlign: "center" }}>This Agreement is made on the date of
                    execution by both parties.</p>
                <form>
                    <section>
                        <p><strong>Between:</strong></p>
                        <p><strong>Dr. Sana Aesthetics Pty Ltd (ABN: 12 345 678
                            901)</strong> ("Aesthetics Consults"), a company
                            providing a telehealth scripting platform, including
                            scripting services, patient management, and cosmetic clinic
                            management functionalities.</p>
                        <div className="divider"></div>
                        <p><strong>And:</strong></p>
                        <p><strong>{getSubmittedData?.organizationName}</strong></p>
                        <p>ABN (if applicable): <strong>{getSubmittedData?.abn}</strong></p>
                        <p>Trading Name: <strong>[Insert Trading Name]</strong></p>
                    </section>
                    <section>
                        <h5 style={{ textAlign: "center" }}>1. Terms and Conditions</h5>
                        <h6 style={{ textAlign: "center" }}>1.1 Definitions</h6>
                        <p>In these terms and conditions, unless the context otherwise
                            requires:</p>
                        <ul>
                            <li>
                                a. <strong>ACL:</strong> Australian
                                Consumer Law
                                Schedule 2
                                of the Competition and Consumer Act 2010 (Cth).
                            </li>
                            <li>b. <strong>Agreement:</strong> These terms and
                                conditions
                                and the Agreement Form; <strong>Agreement Form:</strong>
                                The agreement form signed for and on behalf of the
                                Practitioner.</li>
                            <li>c. <strong>AHPRA:</strong> Australian Health
                                Practitioner
                                Regulation Agency.</li>
                            <li><strong>Joining Fee:</strong> The fee payable by the
                                Practitioner to commence the Agreement, as set out in
                                the Agreement Form.</li>
                            <li>d. <strong>Platform:</strong> The Aesthetics Consults
                                scripting platform and associated infrastructure.</li>
                            <li>e. <strong>Policies:</strong> All policies or similar
                                documents notified to the Practitioner by Aesthetics
                                Consults and as updated from time to time.</li>
                            <li>f. <strong>Practitioner:</strong> The party identified
                                as
                                such in the Agreement Form.</li>
                            <li>g. <strong>Regulatory Requirements:</strong> Obligations
                                imposed by law in relation to the Practitioner, the
                                Platform, or patient treatment, including the Poisons
                                and Therapeutic Goods Act 1966 (NSW) and the Privacy Act
                                1988 (Cth).</li>
                            <li>h. <strong>Scripting Fee:</strong> The fee charged for
                                using the Platform to obtain prescriptions, in
                                accordance with this Agreement.</li>
                            <li>i. <strong>Services:</strong> The services provided by
                                Aesthetics Consults, including software access and
                                support.</li>
                            <li><strong>Software:</strong> All software owned or
                                licensed by Aesthetics Consults.</li>
                            <li>
                                j. <strong>"Platform"</strong> means the Aesthetics
                                Consults system, including but not limited to:
                                <ul>
                                    <li>
                                        i. <strong></strong> Telehealth scripting
                                        services for
                                        obtaining patient prescriptions;
                                    </li>
                                    <li>
                                        ii. <strong></strong> Patient management tools,
                                        including secure
                                        storage
                                        and handling of patient data;
                                    </li>
                                    <li>
                                        iii. <strong></strong> Cosmetic clinic management
                                        functionalities,
                                        such as
                                        appointment scheduling, stock management, and
                                        reporting
                                        tools;
                                    </li>
                                    <li>
                                        iv. <strong></strong> Any associated software,
                                        applications, and
                                        infrastructure provided by Aesthetics Consults
                                        to
                                        facilitate these services.
                                    </li>
                                </ul>
                            </li>

                            <li>k. <strong>Term:</strong> The period commencing on the
                                Commencement Date and ending upon the termination of
                                this Agreement.</li>
                        </ul>
                    </section>
                    <section>
                        <h5 style={{ textAlign: "center" }}>1.2 Terms of Agreement and Commencement</h5>
                        <p>(a) <strong></strong> This Agreement sets out the terms on
                            which Aesthetics Consults grants access to the Platform and
                            provides the Services.</p>
                        <p>(b) <strong></strong> The Agreement commences on the date the
                            Joining Fee is received in full ("Commencement Date") and
                            continues until terminated by either party with 30 days'
                            written notice.</p>
                        <p>(c) <strong></strong> If Services are provided before the
                            Joining Fee is paid, the Practitioner must pay the Joining
                            Fee upon demand.</p>
                    </section>
                    <section>
                        <h5 style={{ textAlign: "center" }}>1.3 Software</h5>
                        <p>
                            (a) <strong></strong> The Software remains the property of
                            Aesthetics Consults or its licensors. A non-transferable,
                            non-exclusive license is granted for use during the Term.
                        </p>
                        <p>
                            (b) <strong></strong> The Practitioner must delete the
                            Software
                            immediately upon
                            termination of this Agreement.
                        </p>
                        <p>
                            (c) <strong></strong> Intellectual property rights in the
                            Software remain with
                            Aesthetics Consults, including:
                        </p>
                        <ul>
                            <li>
                                (i) <strong></strong> All derivative works or adaptations
                                of the Software;
                            </li>
                            <li>
                                (ii) <strong></strong> Data submitted through the
                                Software, which will remain
                                the
                                exclusive property of Aesthetics Consults.
                            </li>
                        </ul>
                        <p>
                            (d) <strong></strong> Users may request access to data they
                            have submitted via the
                            Software.
                        </p>
                        <p>
                            (e) <strong></strong> The Practitioner must comply with all
                            directions regarding
                            the use of the Software and must not:
                        </p>
                        <ul>
                            <li>
                                (i) <strong></strong> Copy, take screenshots of, or
                                distribute any Software data
                                or functionality to third parties;
                            </li>
                            <li>
                                (ii) <strong></strong> Modify, rent, sub-license, or
                                incorporate the Software
                                with
                                other programs without written consent;
                            </li>
                            <li>
                                (iii) <strong></strong> Reverse engineer or create
                                derivative works based on
                                the
                                Software.
                            </li>
                        </ul>
                        <p>
                            (f) <strong></strong> Devices used to access the Software
                            must be kept up to date.
                        </p>
                        <p>
                            (g) <strong></strong> Aesthetics Consults reserves the
                            right to provide
                            Software
                            as a subscription-based service, where required.
                        </p>
                    </section>
                    <section>
                        <h5 style={{ textAlign: "center" }}>1.4 Scripting Fee</h5>
                        <p>
                            (a) <strong></strong> Each completed script incurs a
                            $25 fee.
                        </p>
                        <p>
                            (b) <strong></strong> Practitioners may have up
                            to three (3) rejected
                            scripts per month without incurring a fee. This
                            waiver
                            applies on a monthly basis and is not
                            cumulative.
                            Additional rejected scripts within the same
                            month will
                            incur a $25 fee unless resubmitted following
                            doctor
                            recommendations.
                        </p>
                        <p>
                            (c) <strong></strong> Scripts marked
                            "rejected" by the Platform but
                            resubmitted as recommended by a supervising
                            doctor are
                            exempt from fees.
                        </p>
                        <p>
                            (d) <strong></strong> Aesthetics Consults
                            reserves the right to alter
                            Scripting Fees with 30 days’ written
                            notice.
                        </p>
                        <p>
                            (e) <strong></strong> Invoices are
                            auto-generated monthly, and payments
                            must be processed within seven (7)
                            days of issuance. If
                            an invoice remains overdue,
                            Aesthetics Consults reserves
                            the right to immediately suspend the
                            Practitioner’s
                            access to the Platform until payment
                            is received.
                        </p>
                    </section>
                    <section>
                        <h5 style={{ textAlign: "center" }}>1.5 Joining Fee</h5>
                        <p>
                            (a) <strong></strong> A $2000
                            Joining Fee is payable
                            upon onboarding, covering:
                        </p>
                        <ul>
                            <li>
                                (i) <strong></strong> Data
                                migration (excluding
                                patient purchase/procedure
                                history
                                from the previous system);
                            </li>
                            <li>
                                (ii) <strong></strong>
                                Virtual training sessions on
                                Platform use;
                            </li>
                            <li>
                                (iii) <strong></strong>
                                Location audits,
                                including
                                optional physical site
                                visits.
                            </li>
                        </ul>
                    </section>
                    <section>
                        <h5 style={{ textAlign: "center" }}>1.6 Products</h5>
                        <p>
                            (a) <strong></strong> If
                            the Practitioner uses
                            the Software to order
                            products, they must
                            comply with:
                        </p>
                        <ul>
                            <li>
                                (i) <strong></strong>
                                Third-party supplier
                                terms available on
                                the Platform; and
                            </li>
                            <li>
                                (ii) <strong></strong>
                                Aesthetics Consults’
                                terms of supply.
                            </li>
                        </ul>
                    </section>
                    <section>
                        <h5 style={{ textAlign: "center" }}>1.7 Services</h5>
                        <p>
                            (a) <strong>Platform
                                Role:</strong>
                            Aesthetics Consults
                            provides a platform to
                            assist Practitioners in
                            obtaining scripts or
                            other advice from
                            Consultant Doctors
                            through the Platform.
                            Aesthetics Consults,
                            including Dr. Sana
                            Aesthetics Pty Ltd, is
                            not a healthcare
                            provider or practitioner
                            and does not provide
                            medical advice or
                            services.
                        </p>
                        <p>
                            (b) <strong>Consultant
                                Doctor's
                                Advice:</strong> Any
                            advice or prescriptions
                            provided via the
                            Platform are solely the
                            opinion or
                            recommendation of the
                            Consultant Doctor and do
                            not constitute advice
                            from Aesthetics
                            Consults. The
                            Practitioner
                            acknowledges that it is
                            their sole
                            responsibility, as a
                            healthcare professional,
                            to assess and decide
                            whether to follow the
                            advice or prescriptions
                            provided by the
                            Consultant Doctor.
                            Aesthetics Consults
                            disclaims all liability
                            for any consequences
                            arising from the
                            Practitioner’s decision
                            to act upon or disregard
                            such advice or
                            prescriptions.
                        </p>
                        <p>
                            (c) <strong>Practitioner
                                Responsibility:</strong>
                            The Practitioner
                            acknowledges that the
                            use of the Platform does
                            not remove or reduce
                            their statutory
                            obligations,
                            professional
                            responsibilities as a
                            healthcare practitioner,
                            or any other liabilities
                            under applicable laws
                            and regulations. The
                            Practitioner must
                            exercise their
                            independent professional
                            judgment in all patient
                            interactions,
                            treatments, and
                            decisions.
                        </p>
                        <p>
                            (d) <strong>
                                Platform
                                Updates:</strong>
                            Aesthetics Consults
                            reserves the right to
                            update, modify, or
                            discontinue any part of
                            the Platform at any time
                            without notice, provided
                            such changes do not
                            materially affect the
                            Practitioner’s ability
                            to use the Platform for
                            its intended purpose.
                        </p>
                    </section>
                    <section>
                        <h5 style={{ textAlign: "center" }}>1.8 Practitioner
                            Obligations</h5>
                        <p>
                            (a) <strong></strong> The
                            Practitioner must
                            maintain current AHPRA
                            registration, insurance,
                            and qualifications,
                            providing proof upon
                            request.
                        </p>
                        <p>
                            (b) <strong></strong>
                            Practitioners must not
                            allow unlicensed persons
                            to treat patients.
                        </p>
                        <p>
                            (c) <strong></strong>
                            Practitioners must
                            verify patient
                            identification before
                            issuing prescriptions
                            and comply with all
                            legal and regulatory
                            requirements.
                        </p>
                        <p>
                            (d) <strong></strong>
                            Patient data submitted
                            via the Platform must
                            comply with privacy laws
                            and require appropriate
                            patient consent.

                        </p>
                        <p>
                            (e) <strong></strong>
                            Practitioners must
                            comply with all Policies
                            and Regulatory
                            Requirements.
                        </p>
                        <p>
                            (f) <strong></strong>
                            Practitioners agree to
                            audits conducted by
                            Aesthetics Consults to
                            ensure compliance.
                        </p>
                    </section>
                    <section>
                        <h5>1.9 Indemnity</h5>
                        <p>
                            (a) <strong></strong> By
                            signing this Agreement,
                            the Practitioner
                            indemnifies and holds
                            harmless Aesthetics
                            Consults, including Dr.
                            Sana Aesthetics Pty Ltd,
                            its officers, employees,
                            agents, and contractors,
                            from and against any and
                            all claims, liabilities,
                            damages, losses, costs,
                            or expenses (including
                            reasonable legal fees)
                            arising directly or
                            indirectly from:

                        </p>
                        <ul>
                            <li>
                                (i) <strong></strong>
                                Any breach of this
                                Agreement,
                                applicable laws, or
                                regulatory
                                obligations by the
                                Practitioner;
                            </li>
                            <li>
                                (ii) <strong></strong>
                                The Practitioner’s
                                misuse or
                                unauthorized use of
                                the Platform;
                            </li>
                            <li>
                                (iii) <strong></strong>
                                Any adverse patient
                                outcomes, claims, or
                                damages resulting
                                from the
                                Practitioner’s
                                treatment of
                                patients, including
                                reliance on any
                                advice,
                                prescriptions, or
                                recommendations
                                provided by
                                Consultant Doctors
                                through the
                                Platform;
                            </li>
                            <li>
                                (iv) <strong></strong>
                                The Practitioner’s
                                failure to exercise
                                their independent
                                professional
                                judgment as a
                                healthcare
                                practitioner; and
                            </li>
                            <li>
                                (v) <strong></strong>
                                Any other acts,
                                omissions, or
                                negligence by the
                                Practitioner in
                                connection with the
                                use of the Platform
                                or their
                                professional duties.
                            </li>
                        </ul>
                        <p>
                            (b) <strong></strong> The
                            Practitioner
                            acknowledges that
                            Aesthetics Consults
                            provides the Platform as
                            a tool to facilitate
                            telehealth scripting and
                            patient management but
                            does not assume any
                            liability for medical
                            advice or actions taken
                            by the Practitioner or
                            Consultant Doctors.
                        </p>
                        <p>
                            (c) <strong></strong>
                            This indemnity applies
                            to all actions or claims
                            made by third parties
                            and survives the
                            termination or
                            expiration of this
                            Agreement.
                        </p>
                    </section>
                    <section>
                        <h5 style={{ textAlign: "center" }}>1.10 Termination</h5>
                        <p>
                            (a) <strong>
                                Termination with
                                Notice:</strong>
                            Either party may
                            terminate this Agreement
                            by providing thirty (30)
                            days’ written notice to
                            the other party.
                        </p>
                        <p>
                            (b) <strong>
                                Immediate
                                Termination:</strong>
                            Aesthetics Consults may
                            terminate this Agreement
                            immediately if:
                        </p>
                        <ul>
                            <li>
                                (i) <strong></strong>
                                The Practitioner
                                breaches any terms
                                of this Agreement,
                                applicable laws, or
                                regulatory
                                requirements;
                            </li>
                            <li>
                                (ii) <strong></strong>
                                The Practitioner
                                becomes insolvent,
                                is at risk of
                                insolvency, or fails
                                to meet its
                                financial
                                obligations under
                                this Agreement.
                            </li>
                        </ul>
                        <p>
                            (c) <strong>
                                Data
                                Ownership:</strong>
                            Upon
                            termination of this
                            Agreement, all data
                            stored on or submitted
                            via the Platform remains
                            the sole property of
                            Aesthetics Consults. The
                            Practitioner
                            acknowledges that they
                            have no ownership or
                            proprietary interest in
                            such data.
                        </p>
                        <p>
                            (d) <strong>
                                Data Access
                                Post-Termination:</strong>
                        </p>
                        <ul>
                            <li>
                                (i) <strong></strong>
                                If the Practitioner
                                requests access to
                                any information,
                                including data
                                stored on the
                                Platform or
                                retrieved from
                                backend databases or
                                associated services
                                after termination,
                                Aesthetics Consults
                                may charge a
                                reasonable fee to
                                compensate for the
                                efforts required to
                                retrieve, format,
                                and deliver such
                                information.
                            </li>
                            <li>
                                (ii) <strong></strong>
                                Any request for
                                information must be
                                made in writing,
                                specifying the
                                required data or
                                documents, and
                                Aesthetics Consults
                                reserves the right
                                to decline requests
                                that are overly
                                broad, unreasonable,
                                or in violation of
                                privacy or legal
                                requirements.
                            </li>
                        </ul>
                        <p>
                            (e) <strong>
                                Practitioner
                                Obligations
                                Upon
                                Termination:</strong>
                        </p>
                        <ul>
                            <li>
                                (i) <strong></strong>
                                The Practitioner
                                must immediately
                                cease using the
                                Platform and delete
                                any related software
                                or tools provided by
                                Aesthetics Consults.
                            </li>
                            <li>
                                (ii) <strong></strong>
                                The Practitioner
                                must settle any
                                outstanding fees or
                                obligations owed to
                                Aesthetics Consults
                                before accessing any
                                post-termination
                                services or
                                information
                                retrieval.
                            </li>
                            <p>
                                (f) <strong>
                                    Survival of
                                    Terms:</strong>
                                Termination of this
                                Agreement does not
                                affect the rights or
                                obligations of
                                either party accrued
                                prior to
                                termination.
                                Provisions related
                                to indemnity,
                                liability, data
                                ownership, and
                                confidentiality
                                shall survive
                                termination.
                            </p>
                        </ul>
                    </section>
                    <section>
                        <h5 style={{ textAlign: "center" }}>1.15 Digital
                            Execution and
                            Updates</h5>
                        <p>
                            (a) <strong></strong>
                            This Agreement will
                            be executed
                            digitally through
                            the Aesthetics
                            Consults platform,
                            where both the
                            Practitioner and
                            Consultant will sign
                            electronically by
                            logging into the
                            platform or through
                            a provided secure
                            link.
                        </p>
                        <p>
                            (b) <strong></strong>
                            By digitally signing
                            this Agreement
                            through the
                            platform, both
                            parties acknowledge
                            and agree that such
                            execution is binding
                            and has the same
                            legal effect as a
                            handwritten
                            signature.
                        </p>
                        <p>
                            (c) <strong></strong>
                            Each party warrants that
                            the individual executing
                            this Agreement has the
                            authority to bind their
                            respective party to its
                            terms.
                        </p>
                        <p>
                            (d) <strong></strong> The
                            digitally signed
                            Agreement, including any
                            copies accessible via
                            the platform or provided
                            electronically, shall be
                            deemed original and
                            enforceable for all
                            purposes.
                        </p>
                        <p>
                            (e) <strong></strong> By
                            using the Aesthetics
                            Consults platform, the
                            Practitioner is deemed
                            to have accepted the
                            terms and conditions of
                            this Agreement, whether
                            or not the Agreement has
                            been separately executed
                            digitally.
                        </p>
                        <p>
                            (f) <strong></strong>
                            Aesthetics Consults
                            reserves the right to
                            update or modify the
                            terms and conditions of
                            this Agreement or the
                            Platform at any time.
                            Practitioners will be
                            notified of such updates
                            through email, platform
                            messages, verbal
                            communication, or other
                            appropriate means.
                            Continued use of the
                            Platform following such
                            notification will
                            constitute the
                            Practitioner’s
                            acceptance of the
                            updated terms and
                            conditions.
                        </p>
                    </section>
                    <section>
                        <h5 style={{ textAlign: "center" }}>1.12 General
                            Provisions</h5>
                        <p>
                            (a) <strong></strong>
                            Jurisdiction: This
                            Agreement is governed by
                            New South Wales law.
                        </p>
                        <p>
                            (b) <strong></strong>
                            Severability: Invalid
                            clauses will not affect
                            the enforceability of
                            remaining provisions.
                        </p>
                        <p>
                            (c) <strong></strong>
                            Entire Agreement: This
                            Agreement supersedes
                            prior agreements.
                        </p>
                        <p>
                            (d) <strong></strong>
                            GST: All fees are
                            exclusive of GST.
                        </p>
                    </section>
                    <div style={{ padding: "10px", border: "1px solid #1b1717", borderRadius: "8px" }}>
                        <p>
                            <strong>For the
                                Practitioner</strong>
                        </p>
                        <p>
                            <strong>
                                Name:
                            </strong>
                            <material.TextField
                                type='text'
                                id='name'
                                variant='standard'
                                sx={{ mb: 1, ml: 1, width: "30ch" }}
                                {...register("name", { required: true })}
                            />
                        </p>
                        <div>
                            <strong>
                                Signature:
                            </strong>
                            {getSignatureAgreementData?.isSigned ? (
                                <img
                                    src={getSignatureAgreementData?.data?.data.nurseSignature}
                                />
                            ) : (
                                <>
                                    <SignaturePad penColor='black'
                                        canvasProps={{ height: 200, width: 500, className: 'signaturePad' }}
                                        ref={(ref) => { sigPad = ref }}
                                    />
                                    <span className='ms-2'>
                                        <material.Button size='small' sx={{ textTransform: "none" }} onClick={clear}>Clear</material.Button>
                                    </span>
                                </>
                            )}
                        </div>
                        <p>
                            <strong>
                                Date:
                            </strong>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <material.DatePicker
                                    format='DD-MM-YYYY'
                                    value={date}
                                    disabled
                                    onChange={(newValue) => {
                                        setDate(newValue);
                                    }}
                                    slotProps={{ textField: { variant: 'standard' } }}
                                    sx={{ width: "30%", ml: 1 }}
                                />
                            </LocalizationProvider>
                        </p>
                    </div>
                </form>
            </div>
            <div className="mt-3 me-5">
                <span className='float-end'>
                    {getSignatureAgreementData?.isSigned ? (
                        <material.Button variant='contained' sx={{ textTransform: "none" }} onClick={uploadDocument}>
                            Upload Document
                        </material.Button>
                    ) : (
                        <material.Button variant='contained' sx={{ textTransform: "none" }} onClick={handleSubmit(saveAgreement)}>
                            Save
                        </material.Button>
                    )}
                </span>
            </div>
            <Snackbar
                openSnackBar={openSnackBar}
                setOpenSnackBar={setOpenSnackBar}
            />
        </div>
    );
}

export default NursesAgreement;